<template>
    <div v-bind:class="{ 'is-active': active, 'is-ready': isReady }" class="c-project-video u-fixed u-pos-tl u-fit u-viewport-fit-h u-flex u-align-items-c u-justify-content-c">
        <div class="c-project-video-bg-container u-absolute u-pos-tl u-fit" v-on:click="closeVideo">
            <template v-if="content && content.colors">
                <div v-for="(item, index) in content.colors" v-bind:key="index" v-bind:style="{ background: item.value, transitionDuration: item.duration + 'ms, 0.4s', opacity: item.opacity }" class="c-project-video-bg u-absolute u-pos-tl u-fit"></div>
            </template>
        </div>
        <video-player ref="video" v-if="content && content.video" v-bind:src="content.video" v-bind:autoplay="true" v-bind:sound="false" v-bind:time-update="onVideoTimeUpdate" v-bind:on-ended="onVideoEnded" class="c-project-video-inner u-w12of16 u-relative | u-w10of16@sh | u-w12of16@md">
            <div class="c-project-video-link u-absolute u-flex u-justify-content-sb u-align-items-c u-flex-flow-row-wrap u-fit-w">
                <p v-if="content" class="t-text u-color--white | u-fit-w@sm">Credits: <template v-for="(item, index) in content.credits" ><a v-bind:href="item.url" v-bind:key="index" target="_blank" class="t-text t-link--primary u-color--white">{{item.name}}</a>{{index !== content.credits.length-1 ? ', ' : '' }}</template></p>
                <a v-if="content && content.url" v-bind:href="content.url" target="_blank" class="t-text t-link--primary u-color--white u-marg-t-xs@sm">See the online version</a>
            </div>
        </video-player>
        <button v-on:click="closeVideo" class="c-project-video-close t-btn t-text--sm t-link--primary u-absolute u-pos-tr u-marg-r-md u-color--white u-font-heading | u-marg-r-sm@sm">close</button>
        <div class="c-project-video-prevnext u-absolute u-pos-br u-marg-r-md u-flex u-align-items-c | u-marg-r-sm@sm">
            <button v-on:click="prevVideo" class="c-project-video-prev t-btn t-text--sm t-link--primary t-link--primary u-color--white u-font-heading">prev</button>
            <p class=" text u-color--white  u-marg-x-xs">/</p>
            <button v-on:click="nextVideo" class="c-project-video-next t-btn t-text--sm t-link--primary t-link--primary u-color--white u-font-heading">next</button>
        </div>
    </div>
</template>

<script>
    import videoPlayer from '@/components/videoPlayer';

    export default {
        name: 'videoProject',

        components: {
            videoPlayer,
        },

        props: {
            active: { type: Boolean, default: false },
            closeVideo: { type: Function, default: () => this },
            prevVideo: { type: Function, default: () => this },
            nextVideo: { type: Function, default: () => this },
            project: null,
        },

        data() {
            return {
                isReady: false,
                content: null,
            };
        },

        watch: {
            project: 'onProjectChange',
            active: 'onActiveChange',
        },

        methods: {
            onActiveChange() {
                if (this.active) {
                    this.firstActive = true;
                    this.isReady = true;

                    if (this.$refs.video) {
                        this.$refs.video.onPlay();
                    }
                } else {
                    this.$refs.video.onPause();
                    this.firstActive = false;
                    this.isReady = false;
                }
            },

            onProjectChange() {
                this.isReady = false;

                if (this.firstActive) {
                    setTimeout(() => {
                        this.content = this.project;
                        this.isReady = true;
                    }, 800);
                } else {
                    this.content = this.project;
                    this.isReady = true;
                }

            },

            onVideoTimeUpdate(currentTime) {
                if(!this.project.colors || this.project.colors.length === 0) return;

                this.project.colors.forEach((item) => {
                    if (currentTime*1000 >= item.timing && item.opacity === 0) {
                        item.opacity = 1;
                    } else if(currentTime*1000 < item.timing && item.opacity === 1) {
                        item.opacity = 0;
                    }
                });
            },

            onVideoEnded() {
                this.nextVideo();
            }
        },
    }
</script>

<style lang="stylus">
    @import '../styles/settings/*'

    .c-project-video {
        z-index 200

        opacity 0
        visibility hidden
        transform translateZ(0)
        transition opacity 0.4s $ease-out-quart, visibility 0.4s $ease-out-quart

        &.is-active {
            opacity 1
            visibility visible
            transition opacity 0.8s $ease-out-quart, visibility 0.8s $ease-out-quart
        }

        &-bg-container {
            opacity 0
            transform translateZ(0)
            transition opacity 0.4s $ease-out-quart

            .is-ready & {
                opacity 0.9
                transition opacity 0.8s $ease-out-quart
            }
        }

        &-bg {
            visibility hidden
            transition-property opacity, visibility
            transition-timing-function linear, linear

            .is-ready.is-active & {
                visibility visible
            }
        }

        &-inner {
            aspect-ratio(1152, 720);

            opacity 0
            // transform translateY(80px) translateZ(0)
            transition opacity 0.4s $ease-out-quart, transform 0.4s $ease-out-quart;

            .is-ready & {
                opacity 1
                // transform translateY(0px) translateZ(0)
                transition opacity 0.8s $ease-out-quart, transform 0.8s $ease-out-quart;
            }
        }

        &-cursor {
            width 40px
            height 40px
            border-radius 50%
            border 2px solid white
        }

        &-close {
            top 50px
            transform-origin right bottom
            transform translateY(100%) rotate(-90deg) translateX(100%) translateZ(0)

            @media $breakpoints.sm {
                top: 30px
            }
        }

        &-prevnext {
            bottom 50px
            transform-origin right bottom
            transform  rotate(-90deg) translateX(100%) translateZ(0)

            @media $breakpoints.sm {
                bottom: 30px
            }
        }

        &-link {
            left 0
            bottom -20px
            // bottom -50px

            transform translateY(100%) translateZ(0)
            transition transform 0.8s $ease-out-quart 0.05s;

            .is-ready & {
                // transform translateY(0px) translateZ(0)
            }
        }
    }
</style>